import { useTranslations } from 'next-intl';
import type { MouseEvent, TouchEvent } from 'react';

import type { ItemType } from '@/config/itemTypes';

interface LinesProps {
  setLineType: (
    event: MouseEvent<HTMLButtonElement> | TouchEvent<HTMLButtonElement>,
  ) => void;
  lineTypes: ItemType[];
  lineSelected?: string | null;
  isMobile?: boolean;
}

const Lines = ({
  setLineType,
  lineTypes,
  lineSelected,
  isMobile,
}: LinesProps) => {
  const t = useTranslations();

  return (
    <section id="Lines-container" className="Section Line-controlContainer">
      <h2 className="Section-heading">{t('DRWNG__MENU_ARROWS')}</h2>
      <div className="Section-inner">
        {lineTypes.map((item) => (
          <div
            key={item.variation}
            className={isMobile ? 'Item-container' : ''}
          >
            <button
              onClick={setLineType}
              onTouchStart={setLineType}
              data-name={item.name}
              data-label={t(`DRWNG__ITEM_${item.variation}`)}
              data-variation={item.variation}
              className={`Button Lines-button${lineSelected === item.variation ? ' Lines-button--active' : ''}`}
            >
              <span className="is-visuallyhidden">{item.description}</span>
              <img src={item.defaultIcon.src} alt={item.name} />
            </button>
            {isMobile && <span>{t(`DRWNG__ITEM_${item.variation}`)}</span>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Lines;
